export const CHANNEL_LAYOUT_VALUES = {
  CLASSIC: 1,
  STRIP: 2,
  COMPACT: 3,
};



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/app-settings/constants/channel-layout-values.js